import { useMutation } from "@tanstack/react-query";
import { reportService } from "services";
import {
  ServiceRevenueQuery,
  ServiceRevenueResponse,
  S2cQuery,
  S2dQuery,
  S2eQuery,
  S3Query,
  S4Query,
  S5Query,
  S6Query,
  S7Query,
  TResponse,
} from "types";
import SnackbarUtils from "utils/SnackbarUtils";

export function useReport() {
  const fetchServiceRevenue = useMutation<
    ServiceRevenueResponse | null,
    any,
    ServiceRevenueQuery
  >({
    mutationFn: (params: ServiceRevenueQuery) => reportService.s1Hkd(params),
    onError: (err) => {
      SnackbarUtils.error("Tải báo cáo doanh thu dịch vụ thất bại");
      console.error("fetchServiceRevenue failed", err);
    },
  });

  const fetchS2cHkd = useMutation<TResponse<any> | null, any, S2cQuery>({
    mutationFn: (params: S2cQuery) => reportService.s2cHkd(params),
    onError: (err) => {
      SnackbarUtils.error("Tải báo cáo doanh thu - chi phí thất bại");
      console.error("fetchS2cHkd failed", err);
    },
  });

  const fetchS2dHkd = useMutation<TResponse<any> | null, any, S2dQuery>({
    mutationFn: (params: S2dQuery) => reportService.s2dHkd(params),
    onError: (err) => {
      SnackbarUtils.error("Tải báo cáo tồn kho thất bại");
      console.error("fetchS2dHkd failed", err);
    },
  });

  const fetchS2eHkd = useMutation<TResponse<any> | null, any, S2eQuery>({
    mutationFn: (params: S2eQuery) => reportService.s2eHkd(params),
    onError: (err) => {
      SnackbarUtils.error("Tải báo cáo chi tiết tiền thất bại");
      console.error("fetchS2eHkd failed", err);
    },
  });

  const fetchS3Hkd = useMutation<TResponse<any> | null, any, S3Query>({
    mutationFn: (params: S3Query) => reportService.s3Hkd(params),
    onError: (err) => {
      SnackbarUtils.error("Tải báo cáo chi phí sản xuất, kinh doanh thất bại");
      console.error("fetchS3Hkd failed", err);
    },
  });

  const fetchS4Hkd = useMutation<TResponse<any> | null, any, S4Query>({
    mutationFn: (params: S4Query) => reportService.s4Hkd(params),
    onError: (err) => {
      SnackbarUtils.error("Tải báo cáo tài sản, nguồn vốn thất bại");
      console.error("fetchS4Hkd failed", err);
    },
  });

  const fetchS5Hkd = useMutation<TResponse<any> | null, any, S5Query>({
    mutationFn: (params: S5Query) => reportService.s5Hkd(params),
    onError: (err) => {
      SnackbarUtils.error("Tải báo cáo nghĩa vụ thuế thất bại");
      console.error("fetchS5Hkd failed", err);
    },
  });

  const fetchS6Hkd = useMutation<TResponse<any> | null, any, S6Query>({
    mutationFn: (params: S6Query) => reportService.s6Hkd(params),
    onError: (err) => {
      SnackbarUtils.error("Tải báo cáo công nợ thất bại");
      console.error("fetchS6Hkd failed", err);
    },
  });

  const fetchS7Hkd = useMutation<TResponse<any> | null, any, S7Query>({
    mutationFn: (params: S7Query) => reportService.s7Hkd(params),
    onError: (err) => {
      SnackbarUtils.error("Tải báo cáo sổ tiền thất bại");
      console.error("fetchS7Hkd failed", err);
    },
  });

  return {
    fetchServiceRevenue,
    fetchS2cHkd,
    fetchS2dHkd,
    fetchS2eHkd,
    fetchS3Hkd,
    fetchS4Hkd,
    fetchS5Hkd,
    fetchS6Hkd,
    fetchS7Hkd,
  };
}
